/**
 * 团队协同模块 — Mock API
 * 对标 Salesforce 团队模式
 */

// —— 角色定义 ——
export const ROLES = {
  admin: { label: '超级管理员', color: '#f5222d', level: 4 },
  manager: { label: '营销经理', color: '#722ed1', level: 3 },
  editor: { label: '内容编辑', color: '#1890ff', level: 2 },
  viewer: { label: '只读观察者', color: '#8c8c8c', level: 1 },
};

// —— 角色权限矩阵 ——
export const ROLE_PERMISSIONS = {
  admin: { create: true, edit: true, delete: true, approve: true, export: true, manageMembers: true, manageRoles: true, viewAnalytics: true },
  manager: { create: true, edit: true, delete: false, approve: true, export: true, manageMembers: true, manageRoles: false, viewAnalytics: true },
  editor: { create: true, edit: true, delete: false, approve: false, export: false, manageMembers: false, manageRoles: false, viewAnalytics: true },
  viewer: { create: false, edit: false, delete: false, approve: false, export: false, manageMembers: false, manageRoles: false, viewAnalytics: true },
};

// —— 功能模块列表 ——
export const PERMISSION_MODULES = [
  { key: 'create', label: '创建内容' },
  { key: 'edit', label: '编辑内容' },
  { key: 'delete', label: '删除内容' },
  { key: 'approve', label: '审批发布' },
  { key: 'export', label: '导出数据' },
  { key: 'manageMembers', label: '成员管理' },
  { key: 'manageRoles', label: '角色配置' },
  { key: 'viewAnalytics', label: '查看数据' },
];

// —— 团队成员 Mock 数据（8人）——
const members = [
  {
    id: 1, name: '陈思远', role: 'admin', email: 'siyuan.chen@simoncat.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=siyuan',
    status: 'online', lastActive: '2026-03-15T14:30:00',
  },
  {
    id: 2, name: '林雨晴', role: 'manager', email: 'yuqing.lin@simoncat.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=yuqing',
    status: 'online', lastActive: '2026-03-15T13:45:00',
  },
  {
    id: 3, name: '张子轩', role: 'manager', email: 'zixuan.zhang@simoncat.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=zixuan',
    status: 'away', lastActive: '2026-03-15T11:20:00',
  },
  {
    id: 4, name: '王诗涵', role: 'editor', email: 'shihan.wang@simoncat.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=shihan',
    status: 'online', lastActive: '2026-03-15T14:25:00',
  },
  {
    id: 5, name: '李明辉', role: 'editor', email: 'minghui.li@simoncat.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=minghui',
    status: 'offline', lastActive: '2026-03-14T18:00:00',
  },
  {
    id: 6, name: '赵欣怡', role: 'editor', email: 'xinyi.zhao@simoncat.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=xinyi',
    status: 'online', lastActive: '2026-03-15T14:10:00',
  },
  {
    id: 7, name: '刘浩然', role: 'viewer', email: 'haoran.liu@simoncat.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=haoran',
    status: 'away', lastActive: '2026-03-15T10:30:00',
  },
  {
    id: 8, name: '周梦琪', role: 'viewer', email: 'mengqi.zhou@simoncat.com',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=mengqi',
    status: 'offline', lastActive: '2026-03-13T16:45:00',
  },
];

// —— 任务 Mock 数据（10条）——
const tasks = [
  { id: 1, title: 'Q2 社交媒体内容策略规划', assigneeId: 2, status: 'todo', priority: 'high', deadline: '2026-03-20' },
  { id: 2, title: '小红书爆款文案撰写（3篇）', assigneeId: 4, status: 'in-progress', priority: 'high', deadline: '2026-03-18' },
  { id: 3, title: '抖音短视频脚本创作', assigneeId: 6, status: 'in-progress', priority: 'medium', deadline: '2026-03-22' },
  { id: 4, title: '竞品分析报告整理', assigneeId: 7, status: 'todo', priority: 'low', deadline: '2026-03-25' },
  { id: 5, title: '达人合作方案 PPT 制作', assigneeId: 3, status: 'todo', priority: 'medium', deadline: '2026-03-21' },
  { id: 6, title: '315 促销活动海报设计', assigneeId: 4, status: 'done', priority: 'high', deadline: '2026-03-15' },
  { id: 7, title: '用户画像数据更新', assigneeId: 5, status: 'done', priority: 'medium', deadline: '2026-03-14' },
  { id: 8, title: 'SEO 关键词优化方案', assigneeId: 6, status: 'in-progress', priority: 'medium', deadline: '2026-03-19' },
  { id: 9, title: '品牌合作邮件模板编写', assigneeId: 2, status: 'done', priority: 'low', deadline: '2026-03-12' },
  { id: 10, title: '月度数据看板搭建', assigneeId: 3, status: 'todo', priority: 'high', deadline: '2026-03-28' },
];

// —— 模拟延迟 ——
const delay = (ms = 300) => new Promise((r) => setTimeout(r, ms));

// —— API 方法 ——
export const getMembers = async () => {
  await delay();
  return [...members];
};

export const getRoles = async () => {
  await delay();
  return {
    roles: ROLES,
    permissions: ROLE_PERMISSIONS,
    modules: PERMISSION_MODULES,
  };
};

export const getTasks = async () => {
  await delay();
  return [...tasks];
};

export const assignTask = async (taskData) => {
  await delay();
  const newTask = {
    id: Date.now(),
    ...taskData,
    status: 'todo',
  };
  tasks.push(newTask);
  return newTask;
};

export const updateTaskStatus = async (taskId, status) => {
  await delay();
  const task = tasks.find((t) => t.id === taskId);
  if (task) task.status = status;
  return task;
};

export const updateRole = async (memberId, newRole) => {
  await delay();
  const member = members.find((m) => m.id === memberId);
  if (member) member.role = newRole;
  return member;
};

export const inviteMember = async (email, role) => {
  await delay();
  const newMember = {
    id: Date.now(),
    name: email.split('@')[0],
    role,
    email,
    avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${email}`,
    status: 'offline',
    lastActive: new Date().toISOString(),
  };
  members.push(newMember);
  return newMember;
};

export const removeMember = async (memberId) => {
  await delay();
  const idx = members.findIndex((m) => m.id === memberId);
  if (idx > -1) members.splice(idx, 1);
  return true;
};

export default {
  getMembers,
  getRoles,
  getTasks,
  assignTask,
  updateTaskStatus,
  updateRole,
  inviteMember,
  removeMember,
  ROLES,
  ROLE_PERMISSIONS,
  PERMISSION_MODULES,
};
